const TEMP_ID_PREFIX = 'tmp-';

export const createTempId = (): string =>
	`${TEMP_ID_PREFIX}${crypto.randomUUID()}`;

export const isTempId = (id: string): boolean => id.startsWith(TEMP_ID_PREFIX);
